define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/xml",
	"csi/xml/Query"
], function(array, declare, lang, when, def, Field, Relationship, Widget, xml, Query) {

	return declare(Widget, {
		FIELD_TEMPLATE: "LabelTemplate",

		// String[]: fields controlled by template
		_attributeIds: ["Node Name", "Code", "Description"],

		onSetDefaultValue: function(/*Field*/field, /*Store*/store, /*Any*/value) {
			// summary: hide template field if no values
			if (field.getControlName() == this.FIELD_TEMPLATE) {
				if (store.isStoreEmpty()) {
					this.setFieldHidden(field, true);
					return;
				}

				// select template used to create node if exists
				var node = this.getViewNode();
				if (node) {
					value = null;

					when(store.query({Name: node.$Name}), function(results) {
						if (results.length == 1) {
							value = results[0][store.idProperty];
						}
					});
				}

				if (node = this.cacheView.getNode(value, true)) {
					this.setFieldValue(field, value);
				}

				// set Disabled for non-template fields
				array.forEach(this._attributeIds, function(id) {
					if (field = this.getField(id)) {
						this.setFieldDisabled(field, true);
					}
				}, this);

			} else {
				this.inherited(arguments);
			}
		},

		_onChangeTemplate: function(defView, field, value) {
			// summary: set fields covered by template if active
			if (this.isFieldVisible(field)) {
				var node = this.cacheView.getNode(value, true);
				var bDefault = !field.isUpdated();

				array.forEach(this._attributeIds, function(id) {
					if (field = defView.getField(id)) {
						this.setFieldValue(field, node ? node[id] : "", bDefault);
					}
				}, this);
			}
		},

		_resolveView: function() {
			// summary: insert template select control as first field
			this.insertField(lang.mixin(new Field(), {
				m_bRequired: true,
				m_label: this.FIELD_TEMPLATE,
				m_onChange: "_onChangeTemplate",
				m_typeControl: def.FIELD_FILTERING_SELECT,
				m_relationship: lang.mixin(new Relationship(), {
					m_typeNode: "StructItemNameCode",
					m_query: new Query().Attr("Type", xml.OP_EQUALS, "STRUCTITEMTYPE:" + this.defView.getTypeNode())
				})
			}), 0);

			this.inherited(arguments);
		}
	});
});
